import { render, staticRenderFns } from "./SyncDeptTree.vue?vue&type=template&id=ad698ba4&"
import script from "./SyncDeptTree.vue?vue&type=script&lang=js&"
export * from "./SyncDeptTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports